import { render, staticRenderFns } from "./ArchiveProjectCard.vue?vue&type=template&id=25fba697"
import script from "./ArchiveProjectCard.vue?vue&type=script&lang=js"
export * from "./ArchiveProjectCard.vue?vue&type=script&lang=js"
import style0 from "./ArchiveProjectCard.vue?vue&type=style&index=0&id=25fba697&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports